'use strict';

function objectHasKeys(obj) {
  return obj && Object.keys(obj).length > 0;
}

module.exports = objectHasKeys;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/node_modules/algoliasearch-helper/src/functions/objectHasKeys.js
// module id = 38
// module chunks = 0